import queryString from 'query-string';
import { PureComponent, ReactNode } from 'react';
import { ConnectedProps, connect } from 'react-redux';

import { showModal } from 'modules/main/store/ducks/modal.actions';
import { StaffStoreDispatch } from 'modules/staff/store/StaffStoreDispatch';
import { RouteComponentProps, withRouter } from 'utils/withRouter';

type OwnProps = {
  objectId: string;
  // eslint-disable-next-line react/no-unused-prop-types
  objectName: string;
  render: (arg0: { requestAdmin: () => void }) => ReactNode;
};

type Props = PropsFromRedux & RouteComponentProps & OwnProps;

class AdminRequestContainer extends PureComponent<Props> {
  componentDidMount() {
    this.checkQueryParam();
  }

  componentDidUpdate() {
    this.checkQueryParam();
  }

  checkQueryParam() {
    const { modal } = this.props;

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.userEnvironment.isUserLoaded) {
      return;
    }

    const otherModalShown =
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      modal && modal.type && modal.type !== 'ADMIN_REQUEST';
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    const queryParams = queryString.parse(this.props.location.search);

    if (queryParams['admin-request'] === 'true' && !otherModalShown) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.showAdminRequestModal();
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.navigate(this.props.location.pathname);
    }
  }

  render() {
    const {
      userEnvironment,
      render,
      loggedIn,
      showAdminRequestModal,
      showEmailSignupModal,
      objectId,
    } = this.props;

    const isAdmin =
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      userEnvironment.user &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      userEnvironment.user.orgs.find((org: any) => org.id === objectId);

    if (!userEnvironment.isUserLoaded || isAdmin) return null;

    return (
      <>
        {render({
          requestAdmin: loggedIn ? showAdminRequestModal : showEmailSignupModal,
        })}
      </>
    );
  }
}

const mapStateToProps = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { userEnvironment, modal }: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { objectType, objectId }: any,
) => ({
  userEnvironment,
  objectType,
  objectId,
  loggedIn: Boolean(userEnvironment.user),
  modal,
});

const mapDispatchToProps = (
  dispatch: StaffStoreDispatch,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { objectType, objectId, objectName, location }: any,
) => ({
  showAdminRequestModal: () => {
    dispatch(
      showModal('ADMIN_REQUEST', {
        objectType,
        objectId,
        objectName,
      }),
    );
  },
  showEmailSignupModal: () => {
    dispatch(
      showModal('EMAIL_SIGNUP', {
        title:
          /* TRANSLATORS: title of dialog to request to be admin of org */
          getText('Request to Become an Administrator'),
        redirectTo: `${location.pathname}?admin-request=true`,
      }),
    );
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

// eslint-disable-next-line import/no-default-export
export default withRouter(connector(AdminRequestContainer));
